import i18n from "@/i18n";
import initLang from "@/utils/lang";
import {localStorageSet, LANG} from "@/localStorage";

export const state = {
  lang: initLang
}

export const mutations = {
  SET_LANG(state, lang) {
    state.lang = lang
  },
}

export const getters = {}

export const actions = {
  changeLanguage({commit}, lang) {
    localStorageSet(LANG, lang)
    i18n.locale = lang
    window.document.querySelector('html').setAttribute('lang', lang)
    commit('SET_LANG', lang)
  },
}
